import { TypedContainer } from "./_Base";
export class JsContainer extends TypedContainer {
  object() {
    return this._content;
  }
}
